

import VerifyEmail from "./Pages/VerifyEmail";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import ForgotPassword from "./Pages/ForgotPassword";
import { development_mode } from "./services/Constant";
import NotFound from "./Pages/NotFound";
const route = development_mode ? "test-authorization" : "authorization";

const theme = createTheme({
  palette: {
    mode: "light", // Change to "dark" for dark mode or make dynamic
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path={`/${route}/reset-password/:fp_token`}
            element={<ForgotPassword />}
          />
          <Route
            path={`/${route}/verify-email/:ev_token`}
            element={<VerifyEmail />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
